// extracted by mini-css-extract-plugin
module.exports = {"descrptionSection":"our-customers-component_descrptionSection__2iHM-","mentionSection":"our-customers-component_mentionSection__3k6VG"};